import { useSyncExternalStore } from "react";
import type { Comment, Post, UserSummary } from "@atrium/shared";

/*
 * Report slot. The moderation module owns report dialogs and the reports API;
 * it registers a handler here once and every post, comment and profile menu
 * shows "Report" wired to it. Until a handler is registered the item is hidden.
 *
 *   registerReportHandler((target) => openReportDialog(target));
 */

export type ReportTarget = { type: "post"; post: Post } | { type: "comment"; comment: Comment; postId: string } | { type: "user"; user: UserSummary };
type Handler = (target: ReportTarget) => void;

let handler: Handler | null = null;
const listeners = new Set<() => void>();

export function registerReportHandler(fn: Handler | null) {
  handler = fn;
  listeners.forEach((l) => l());
}

/** The registered report handler, or null when reporting isn't available. */
export function useReportHandler(): Handler | null {
  return useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    () => handler,
  );
}
